import { fetchApi, fetchApiFile } from "./utils";

export const getPages = async () => fetchApi("/pages", { method: "GET" });

export const getPageDetailsByPageName = async (pageName) =>
  fetchApi(`/page-by-name?name=${pageName}`, { method: "GET" });

export const updateProfileInfoSettings = async (data) =>
  fetchApi(`/page-settings-info?`, { method: "POST", params: { data } });

export const updateDisplayLogoOrUsername = async (data) =>
  fetchApi(`/page-display`, { method: "POST", params: { data } });

export const updateNamePage = async (data) =>
  fetchApi(`/update-page-name`, { method: "POST", params: { data } });

export const checkPageNameAvailability = async (data) =>
  fetchApi(`/check-name-availability`, { method: "POST", params: { data } });

export const updateSocialIcons = async (PageID, data) =>
  fetchApi(`/update-socials`, { method: "POST", params: { PageID, data } });

export const updateScripts = async (PageID, data) =>
  fetchApi(`/update-scripts`, { method: "POST", params: { PageID, data } });

export const createNewPage = async (PageName) =>
  fetchApi(`/new-page`, { method: "POST", params: { PageName } });

export const createNewPageWelcome = async (data) =>
  fetchApi(`/new-page-welcome`, { method: "POST", params: { data } });

export const deletePage = async (PageID) =>
  fetchApi(`/page?PageID=${PageID}`, { method: "DELETE" });

export const uploadProfilePictureToAWS = async (formData, pageID) => {
  let imageUrl = await fetchApiFile(
    `/upload-profile-picture?pageID=${pageID}`,
    {
      method: "POST",
      params: formData,
    }
  );
  return imageUrl;
};

export const uploadProfilePictureToAWSWithoutSaving = async (formData) => {
  let res = await fetchApiFile(`/upload-profile-picture-no-save`, {
    method: "POST",
    params: formData,
  });
  console.log(res);
  return res;
};
